export default function Pending() {
	return (
		<svg width="14" height="15" viewBox="0 0 14 15" fill="none" className="toast__icon">
			<g>
				<g>
					<circle cx="7" cy="7.5" r="7" fill="white" />
				</g>
				<path d="M6.80005 4V8.5H10.8" stroke="#404040" strokeWidth="1.5" strokeLinecap="round" />
			</g>
		</svg>
	);
}
